/**
 * Create the store with asynchronously loaded reducers
 */

import { compose, createStore, applyMiddleware } from 'redux';
import allReducers from './reducers/index';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import { sagaWatcher } from './sagas/index';
const saga = createSagaMiddleware();

const composeSetup =
  process.env.NODE_ENV !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const rootReducer = (state, action) => {
  if (action.type === 'RESET_APP') {
    state = undefined;
  }
  return allReducers(state, action);
};

const store = createStore(rootReducer, composeSetup(applyMiddleware(thunk, saga)));

saga.run(sagaWatcher);

export default store;
